import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getBannerPosition'
})
export class GetBannerPositionPipe implements PipeTransform {

  position: string = '';

  transform(n: number): unknown {
    if (n === 1) {
      this.position = 'Arriba'
    }
    return this.position;
  }

}
